<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-toolbar cad color="primary" dark dense flat>
            <v-toolbar-title class="subheading">
              {{ $route.meta.title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-card-text>
            <v-form>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-subheader class="pa-0 mt-3"
                    >DETALLES DEL DISTRIBUIDOR</v-subheader
                  >
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('name')"
                    data-vv-name="name"
                    label="Nombre"
                    required
                    v-model="form.name"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('phone')"
                    data-vv-name="phone"
                    label="Teléfono"
                    required
                    v-model="form.phone"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-combobox
                    no-data-text="Datos no disponibles"
                    chips
                    label="Emails para Notificaciones"
                    multiple
                    v-model="form.emails"
                  ></v-combobox>
                </v-flex>
                <v-flex md12 xs12>
                  <v-textarea
                    data-vv-name="address"
                    label="Dirección"
                    textarea
                    v-model="form.address"
                  ></v-textarea>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="pa-0 mt-3">LABORATORIO</v-subheader>
                </v-flex>
                <v-flex md12 xs12>
                  <v-select
                    no-data-text="Datos no disponibles"
                    :error-messages="errors.collect('laboratories')"
                    :items="laboratories"
                    item-text="name"
                    item-value="id"
                    chips
                    data-vv-name="laboratories"
                    label="Laboratorios"
                    multiple
                    v-model="form.laboratories"
                    v-validate="'required'"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-subheader class="pa-0 mt-3"
                    >PERSONA DE CONTACTO</v-subheader
                  >
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('firstName')"
                    data-vv-name="firstName"
                    label="Nombre"
                    required
                    v-model="form.contact.firstName"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('lastName')"
                    data-vv-name="lastName"
                    label="Apellido"
                    required
                    v-model="form.contact.lastName"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :error-messages="errors.collect('email')"
                    data-vv-name="email"
                    label="Email"
                    required
                    type="email"
                    v-model="form.contact.email"
                    v-validate="'required|email'"
                  ></v-text-field>
                </v-flex>
                <v-flex md6 xs12>
                  <v-text-field
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    :error-messages="errors.collect('password')"
                    :type="showPassword ? 'text' : 'password'"
                    @click:append="showPassword = !showPassword"
                    data-vv-name="password"
                    label="Contraseña"
                    required
                    v-if="!form.id"
                    v-model="form.contact.password"
                    v-validate="'required'"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-subheader class="pa-0 mt-3">CONTABLE</v-subheader>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    no-data-text="Datos no disponibles"
                    :items="accountings"
                    item-text="name"
                    item-value="id"
                    label="Contable"
                    v-model="form.accId"
                  ></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-btn @click="submit" color="success">Enviar</v-btn>
                  <v-btn
                    @click="$router.push('/distribuidores/listado')"
                    color="error"
                    >Cancelar</v-btn
                  >
                </v-flex>

                <v-dialog
                  max-width="500"
                  v-if="dialog.message"
                  v-model="dialog.show"
                >
                  <message
                    :options="dialog"
                    v-on:close="dialog.show = false"
                  ></message>
                </v-dialog>
              </v-layout>
            </v-form>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import message from './../dialog/Message'
export default {
  components: {
    message,
  },
  props: {
    form: {
      type: Object,
      default() {
        return {
          name: '',
          phone: '',
          address: '',
          emails: [],
          contact: {
            firstName: '',
            lastName: '',
            email: '',
            password: '',
          },
          laboratories: [],
          accId: '',
        }
      },
    },
  },
  data() {
    return {
      showPassword: false,
      accountings: [],
      laboratories: [],
      multi: [],
      dialog: {
        show: false,
      },
    }
  },

  created() {
    this.$store.dispatch('users/getAll', { roleId: 3 }).then(response => {
      const data = response.items
      for (let index = 0; index < data.length; index += 1) {
        this.accountings.push({
          name: `${data[index].firstName} ${data[index].lastName}`,
          id: data[index].id,
        })
      }
    })

    this.$store
      .dispatch('laboratories/getAll', { roleId: 3 })
      .then(response => {
        const data = response.items
        for (let index = 0; index < data.length; index += 1) {
          this.laboratories.push({
            name: data[index].name,
            id: data[index].id,
          })
        }
      })

    if ('id' in this.$route.params) {
      this.$store
        .dispatch('distributors/getById', {
          id: this.$route.params.id,
        })
        .then(response => {
          if (response) {
            const emails = response.emails ? response.emails.split(',') : []

            const laboratories = response.laboratories.reduce((acc, lab) => {
              let { id } = lab
              acc.push(id)
              return acc // returns object with property x
            }, [])

            this.form = Object.assign(this.form, {
              id: response.id,
              name: response.name,
              phone: response.phone,
              address: response.address,
              emails: emails,
              laboratories: laboratories,
              contact: {
                firstName: response.contact.firstName,
                lastName: response.contact.lastName,
                email: response.contact.email,
              },
              accId: response.accounting !== null ? response.accounting.id : '',
            })
          } else {
            this.$router.push('/distribuidores/listado')
          }
        })
    }
  },
  methods: {
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$store
            .dispatch('distributors/save', this.form)
            .then(response => {
              if (response.status === 200) {
                if (this.form.id) {
                  this.dialog = {
                    message: 'Los datos fueron actualizados exitosamente',
                    color: 'primary',
                    show: true,
                  }
                } else {
                  this.$router.push('/distribuidores/listado')
                }
              } else {
                this.dialog = {
                  message: response.data.error,
                  color: 'error',
                  show: true,
                }
              }
            })
        }
      })
    },
  },
}
</script>
